"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldCondition = void 0;
const condition_1 = require("./condition");
const operator_1 = require("./operator");
class FieldCondition extends condition_1.Condition {
    constructor() {
        super(...arguments);
        this.fieldAccessor = '';
        this.operator = new operator_1.Operator();
    }
    static create(fieldAccessor, value, operatorType, operatorName) {
        let fieldCondition = new FieldCondition();
        fieldCondition.fieldAccessor = fieldAccessor;
        fieldCondition.value = value;
        fieldCondition.operator = operator_1.Operator.getOp(operatorType, operatorName);
        return fieldCondition;
    }
}
exports.FieldCondition = FieldCondition;



//////////////////
// WEBPACK FOOTER
// ./~/rules-config/lib/field-condition.js
// module id = 1253
// module chunks = 0